export function handleSlideNavigation(event, slideIndex, context) {
  event.preventDefault();
  let videos = document.querySelectorAll('.paragraph--type--video iframe');
  let audios = document.querySelectorAll('.field audio');
  // pause any audio elements that are playing
  audios.forEach(function(audioElement) {
    try {
      if (!audioElement.paused) {
        audioElement.pause();
      }
    } catch (error) {
      console.log('Could not pause audio:', error);
    }
  });

    videos.forEach(function(video) {
      const src = video.src;
      
      try {
        if (src.includes('youtube.com') || src.includes('youtu.be')) {
          video.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
        }
        else if (src.includes('vimeo.com')) {
          video.contentWindow.postMessage('{"method":"pause"}', '*');
        }
      } catch (error) {
        console.log('Could not pause video:', error);
      }
    });
  let slides = document.querySelectorAll('.field--name-field-slides > .field__item');
  let slideContainer = document.querySelector('.field--name-field-slides');
  let onFirstSlide = parseInt(slideIndex) === 0;
  let sectionHasOnlyOneSlide = slides.length === 1;
  // this first part (including the if (onLastSLide) part ) deals with the situation where the user is
  // on the last slide but has slicked the prev btn. in that case, we want to hide
  // the next section button and show the next btn so they can get back to the last slide
  let onLastSlide = null;
  if(event.target.matches('.slide-control-prev') || event.target.matches('.slide-control-prev *')) {
    onLastSlide = parseInt(slideIndex) === slides.length - 2;
  } else {
    onLastSlide = parseInt(slideIndex) === slides.length - 1;
  }
  if (onLastSlide) {
    document.querySelector('.next-section-button').classList.add('btn-hidden');
    document.querySelector('.slide-control-next').classList.remove('btn-hidden');
    document.querySelector('.slide-navigation-container').classList.remove('last-slide');
    // edge case where someone has jumped to the last slide without
    // ever going through the slides
    if(document.querySelector('.slide-control-prev').classList.contains('btn-hidden') && !sectionHasOnlyOneSlide) {
      // if it is, then we need to show it
      document.querySelector('.slide-control-prev').classList.remove('btn-hidden');
    }
  }
  // this part deals with the situation where the user is on the first slide
  if(!onFirstSlide) {
    document.querySelector('.previous-section-button').classList.add('btn-hidden');
    document.querySelector('.previous-section-button').setAttribute('aria-hidden', 'true');
    document.querySelector('.slide-control-prev').classList.remove('btn-hidden');
  } else {
    document.querySelector('.previous-section-button').classList.remove('btn-hidden');
    document.querySelector('.previous-section-button').removeAttribute('aria-hidden');
    if(!document.querySelector('.slide-control-prev').classList.contains('btn-hidden') && !sectionHasOnlyOneSlide) {
      document.querySelector('.slide-control-prev').classList.add('btn-hidden');
    }
  }
  // now this is the normal functionality after that prev edge case
  slides.forEach(function(slide) {
    slide.classList.remove('active');
    // the field--field-slides template is set make each slide aria-hidden by default
    // but we want to make sure that the previously shown slide is set to be aria hidden as well
    // plus this will make sure that if someone goes to a url that's in the middle of the slides
    // the accessibility works correctly by making sure that slide is not hidden and the others are
    slide.setAttribute('aria-hidden', 'true');
    // then when it's active we want to set it to false which is done later in this file
  });
  let slideIndicatorItems = jQuery('.slide-indicator-item', context);
  slideIndicatorItems.each(function(index, element) {
    let i = jQuery(element).attr('data-slide-index');
    if(parseInt(i) <= parseInt(slideIndex)) {
      jQuery(element).addClass('has-been-shown');
    } else {
      jQuery(element).removeClass('has-been-shown');
    }
  });
  // this is the actual "go to the next slide or prev slide" part

  let thisSlide = slideContainer.querySelector(`.field--name-field-slides > .field__item[data-slide-index="${slideIndex}"]`);
  thisSlide.classList.add('active');
  // change aria-hidden to false for the current slide
  thisSlide.setAttribute('aria-hidden', 'false');
  
  let paragraph = jQuery(thisSlide).children('.paragraph');
  let thisSlideID = paragraph.attr('id');
  if(thisSlideID.includes('slide-')) {
    if(history.replaceState) {
      history.replaceState(null, null, '#' + thisSlideID);
    }
  }

  // and take the user to the top of the window 
  window.scrollTo(0, 0);
  let prevButton = document.querySelector('.slide-control-prev');
  let nextButton = document.querySelector('.slide-control-next');
  if(slideIndex > 0) {
    prevButton.setAttribute('data-slide-index', parseInt(slideIndex) - 1);
  } else {
    prevButton.setAttribute('data-slide-index', 0);
  }
  if(slideIndex < slides.length - 1) {
    nextButton.setAttribute('data-slide-index', parseInt(slideIndex) + 1);
  } else {
    let nextSectionButton = document.querySelector('.next-section-button');
    nextSectionButton.classList.remove('btn-hidden');
    nextButton.classList.add('btn-hidden');
    nextButton.setAttribute('aria-hidden', 'true');
    document.querySelector('.slide-navigation-container').classList.add('last-slide');
  }
}

export default function updateTabIndices() {
  const slides = document.querySelectorAll('.field--name-field-slides > .field__item');
  if (slides.length === 0) {
    return;
  }
  // the external links module is modifying links and removing the tabindex 0
  // so we are going to use a window timeout to wait a bit, make sure ext links does its thing
  // then we will set the tabindex
  window.setTimeout(() => {
    slides.forEach(slide => {
      const links = slide.querySelectorAll('a');
      const buttons = slide.querySelectorAll('button');
      // we also want to make sure that any iframes are not focusable
      const iframes = slide.querySelectorAll('iframe');
      const allFocusableElements = [...links, ...buttons, ...iframes];

      if (slide.classList.contains('active')) {
        // Enable tabbing for links, buttons, and iframes in active slide
        allFocusableElements.forEach(element => element.setAttribute('tabindex', '0'));
      } else {
        // Disable tabbing for links, buttons, and iframes in non-active slides
        allFocusableElements.forEach(element => element.setAttribute('tabindex', '-1'));
      }
    });
  }, 1000);
}